import { NudosCareTag, NudosTextInput } from '../../../../../../components/NudosComponents';
import NudosProductPills from '../../../../../../components/NudosComponents/NudosProductPills/NudosProductPills';
import { IConfigurationTool } from '../../../../../../types/product.configuration.types';
import { IpillsByReference } from '../../../../../../types/orders';
import { getConfigClass } from '../../../../../../utils/configurations';
import useConfigurationGlobalState from '../configurationGlobalState';

const ToolsAsociatedConfigModalContent = ({
  filteredUnits,
  searchText,
  setSearchText
}: {
  filteredUnits: IConfigurationTool[];
  searchText: string;
  setSearchText: (value: string) => void;
}) => {
  const { configUnit } = useConfigurationGlobalState();
  const configClass = getConfigClass(configUnit?.configClassId);

  return (
    <div className="w-full px-8 mt-2">
      <div className="text-xs font-bold mb-4">
        Lista de unidades con la configuración {configUnit?.name} de {configClass?.name}
      </div>

      <NudosTextInput
        isFilled={!!searchText}
        defaultValue={searchText}
        handleChange={setSearchText}
        placeholder="Busca por serial o nombre"
      />

      <div className="configModalToolsContainer">
        {filteredUnits?.map(unit => {
          const formattedPills =
            typeof unit.pills === 'string' ? (JSON.parse(unit.pills) as IpillsByReference) : unit.pills || {};

          return (
            <div key={unit.id} className="toolsAsociatedConfigModalUnit">
              <div className="flex items-center gap-2">
                <span className="text-xs">{unit.name}</span>
                <NudosProductPills pills={formattedPills} />
                <NudosCareTag nudosCareType={unit.careType} />
              </div>

              <div className="toolsAsociatedConfigModalData">
                <span>
                  Serial: <strong>{unit.serial}</strong>
                </span>
                <span>
                  SKU: <strong>{unit.sku}</strong>
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ToolsAsociatedConfigModalContent;
